module.exports = __webpack_public_path__ + "img/business_model_list4.c2a370dc.png";